import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parse } from 'query-string';
import Form from 'comps/form';
import { Button, Text, Separator, Row } from '@cuemath/comps';
import {
  PlusLeadOptions,
  genderOptions as Genders,
  // referralOptions as Sources,
  leadSourceOptions as Sources,
  GradeOptions,
  EthnicityOptions,
  eventOptions as Events,
  organicLeadOptions,
  MODAL_FORM,
  sourceValues,
  OPTIONS,
} from 'constants/form';
import { CopyButton } from 'comps';
import { COLORS } from '@cuemath/comps';
import { COUNTRY_OPTIONS } from 'constants/country-code-map';
import { openModal } from 'actions/modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import { trackEvent } from 'modules/analytics';
import { EVENT_TYPE } from 'constants/logger';

const IS_AMBASSADOR = 'is_ambassador';
const PARENT_FORM = [
  {
    id: OPTIONS.PARENT_NAME,
    label: 'Parent Name',
    type: 'text',
    maxLength: '50',
    autoFocus: true,
  },
  {
    label: 'Country Code',
    id: OPTIONS.COUNTRY_CODE,
    type: 'text',
  },
  {
    label: 'Primary Number',
    id: OPTIONS.PHONE,
    type: 'tel',
  },
  {
    label: 'Email',
    id: OPTIONS.EMAIL,
    type: 'email',
  },
  {
    id: 'ambassador_checkbox',
    name: 'ambassador_checkbox',
    label: 'Select the option below',
    type: 'checkbox',
    options: [{ id: IS_AMBASSADOR, value: 'Ambassador' }],
    feedbackType: 'widget',
  },
  {
    label: 'Source',
    id: OPTIONS.SOURCE,
    type: 'dropdown',
    options: Sources,
  },
];

const STUDENT_FORM = [
  {
    label: 'First Name',
    id: OPTIONS.FIRST_NAME,
    maxLength: '50',
    type: 'text',
  },
  {
    label: 'Last Name',
    id: OPTIONS.LAST_NAME,
    maxLength: '50',
    type: 'text',
  },
  {
    id: OPTIONS.GENDER,
    label: 'Gender (Optional)',
    type: 'dropdown',
    options: Genders,
  },
  {
    id: OPTIONS.GRADE,
    label: 'Grade',
    type: 'dropdown',
    options: GradeOptions,
  },
  {
    id: OPTIONS.SCHOOL_NAME,
    label: 'School Name (Optional)',
    maxLength: '100',
    type: 'text',
  },
  {
    id: OPTIONS.ETHNICITY,
    label: 'Ethnicity (Optional)',
    type: 'dropdown',
    options: EthnicityOptions,
  },
  {
    id: OPTIONS.PLUS_LEAD,
    label: 'Plus Lead',
    type: 'dropdown',
    options: PlusLeadOptions,
  },
];

const REFERRAL_FORM = [
  {
    label: 'Referrer Country Code',
    id: OPTIONS.REFERRER_COUNTRY_CODE,
    type: 'dropdown',
    options: COUNTRY_OPTIONS,
  },
  {
    label: 'Referrer Primary Number',
    id: OPTIONS.REFERRER_PHONE,
    type: 'tel',
  },
];

const EMPLOYEE_REFERRAL_FORM = [
  {
    label: 'Employee Email',
    id: OPTIONS.EMPLOYEE_EMAIL,
    type: 'email',
  },
];

const UAE_LOCAL_FORM = [
  {
    id: OPTIONS.EVENT_TYPE,
    label: 'Event Type',
    type: 'dropdown',
    options: Events,
  },
  {
    id: OPTIONS.EVENT_NAME,
    label: 'Event Name',
    maxLength: '50',
    type: 'text',
  },
];

const ORGANIC_LOCAL_FORM = [
  {
    id: OPTIONS.INFORMATION_SOURCE,
    label: 'Information Source',
    type: 'dropdown',
    options: organicLeadOptions,
  },
];

class AddParentStudentForm extends Component {
  constructor(props) {
    super(props);
    const { parentData, primaryNumber } = props;
    const { leads = [], is_ambassador: isAmbassador } = parentData || {};
    const { first_name: firstName, last_name: lastName, email, phone } = leads[0] || {};
    const disables = { phone: true, countryCode: true, Next: true };

    if (parentData.leads[0]) {
      PARENT_FORM.forEach(f => {
        disables[f.id] = true;
      });
    }

    this.state = {
      form: {
        firstName,
        lastName,
        email,
        countryCode: parse(window.location.search).countryCode,
        phone: phone || primaryNumber || parse(window.location.search).phone,
        gender: undefined,
        grade: undefined,
        parentName: undefined,
        schoolName: undefined,
        source: undefined,
        referrerCountryCode: undefined,
        referrerPhone: undefined,
        employeeEmail: undefined,
        ethnicity: undefined,
        plusLead: undefined,
        event_type: undefined,
        event_name: undefined,
        google_api_info: {},
        ambassador_checkbox: isAmbassador ? [IS_AMBASSADOR] : [],
      },
      validation: {},
      error: {},
      disables,
      page: 1,
      msgToDisplay: { success: '', error: '' },
      isStale: false,
      isLoading: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { postParentResponse, postStudentResponse } = props;
    const { isStale, form } = state || {};
    const { resolved: postParentResponseResolved } = postParentResponse || {};
    const {
      isCreated: postParentIsCreated,
      isCreatingFailed: postParentIsCreatingFailed,
    } = postParentResponseResolved || {};
    if (postParentIsCreatingFailed && !isStale) {
      const error = store.getError(postParentResponseResolved);
      const { message } = error || {};
      return {
        msgToDisplay: { success: '', error: message || 'Something went wrong.' },
        isStale: true,
        isLoading: false,
      };
    }
    if (postParentIsCreated && !isStale) {
      const { data = {} } = postParentResponseResolved || {};
      const { is_valid_referral: isValidReferral } = data || {};
      if (isValidReferral) {
        return {
          msgToDisplay: { success: 'Referral acknowledged.', error: '' },
          disables: { ...state.disables, Next: false, Save: true },
          isStale: true,
          isLoading: false,
        };
      } else {
        if (form?.source?.value === 'Referral' && isValidReferral === false) {
          return {
            msgToDisplay: {
              success: 'Parent created.',
              error: `Referrer doesn't qualify for referral program.`,
            },
            disables: { ...state.disables, Next: false, Save: true },
            isStale: true,
            isLoading: false,
          };
        } else {
          return {
            msgToDisplay: {
              success: 'Parent created.',
            },
            disables: { ...state.disables, Next: false, Save: true },
            isStale: true,
            isLoading: false,
          };
        }
      }
    }

    const { resolved: postStudentResponseResolved } = postStudentResponse || {};
    const {
      isCreatingFailed: postStudentIsCreatingFailed,
      isCreated: postStudentIsCreated,
    } = postStudentResponseResolved || {};
    if (postStudentIsCreatingFailed && !isStale) {
      const error = store.getError(postStudentResponseResolved);
      const { message } = error || {};
      return {
        msgToDisplay: { success: '', error: message || 'Something went wrong.' },
        isStale: true,
        isLoading: false,
      };
    }
    if (postStudentIsCreated && !isStale) {
      return { msgToDisplay: { success: '', error: '' }, isStale: true };
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { postParentResponse: prevPostParentResponse } = prevProps;
    const { resolved: prevResolved } = prevPostParentResponse || {};
    const { isCreated: prevIsCreated, isCreatingFailed: prevIsCreatingFailed } =
      prevResolved || {};

    const { postParentResponse } = this.props;
    const { resolved } = postParentResponse || {};
    const { isCreated, isCreatingFailed, data } = resolved || {};
    const { parent_id: parentId, is_valid_referral: isValidReferral } = data || {};

    const { form } = this.state;
    const { email, phone, countryCode, parentName, source, referrerPhone } = form;

    const eventData = {
      email,
      phone,
      countryCode,
      parentName,
      source: source && source.value,
      referrerPhone,
      detail_source: 'LA_REF',
      parentId,
      isValidReferral,
    };

    if (!prevIsCreated && isCreated) {
      trackEvent(EVENT_TYPE.ADD_LEAD, { ...eventData, status: 'success' });
      this.setState({ disables: { ...this.state.disables, Next: false, Save: true } });
    }
    if (!prevIsCreatingFailed && isCreatingFailed) {
      trackEvent(EVENT_TYPE.ADD_LEAD, { ...eventData, status: 'failed' });
    }
  }

  saveClick = event => {
    const { postParent = {}, postParentResponse = {} } = this.props;
    const { form, isLoading } = this.state;
    const { current = {} } = postParentResponse || {};
    const {
      email,
      phone,
      countryCode,
      parentName,
      source,
      referrerCountryCode,
      referrerPhone,
      employeeEmail,
      event_type,
      event_name,
      information_source,
      ambassador_checkbox,
    } = form;

    const parentDetailsForm = {
      email,
      phone,
      countryCode,
      parentName,
      source,
      referrerCountryCode,
      referrerPhone,
      employeeEmail,
      event_name,
      event_type,
      information_source,
    };
    if (current && current.isCreating) {
      return;
    }
    const requiredFieldsError = {};
    const notFilled = Object.keys(parentDetailsForm).filter(k => {
      if (this.nonOptinalField(k, form)) {
        requiredFieldsError[k] = 'Required';
      }

      return this.nonOptinalField(k, form);
    });
    if (notFilled.length) {
      this.setState({ error: { fields: requiredFieldsError } });
      return;
    }

    let payload = {
      action: 'create_parent',
      phone,
      email,
      country_code: countryCode,
      parent_name: parentName,
      source: source && source.value,
      detail_source: 'LA_REF',
      is_ambassador: ambassador_checkbox?.includes(IS_AMBASSADOR) ? true : false,
    };
    if (source?.value === sourceValues.EMPLOYEE_REFERRAL) {
      payload = {
        ...payload,
        cuemath_referrer_email_id: employeeEmail,
      };
    } else if (
      source?.value === sourceValues.PARENT_REFERRAL ||
      source?.value === sourceValues.SALES_REFERRAL
    ) {
      payload = {
        ...payload,
        referrer_phone: referrerPhone,
        detail_source: 'LA_REF',
      };
    } else if (source?.value === sourceValues.UAE_LOCAL) {
      payload = {
        ...payload,
        event_type: event_type && event_type.value,
        event_name: event_name,
        detail_source: '',
      };
    } else if (source?.value === sourceValues.ORGANIC) {
      payload = {
        ...payload,
        information_source: information_source && information_source.value,
        detail_source: information_source && information_source.value,
      };
    }

    if (postParentResponse && postParentResponse.isCreating) {
      return;
    }

    if (isLoading) return;
    this.setState({ isStale: false, isLoading: true, error: {} });
    postParent(postParentResponse.id, payload);
  };

  nextClick = () => {
    const { parentId } = this.props;
    const { page } = this.state;
    if (page === 1) {
      this.setState({
        page: 2,
        msgToDisplay: { success: '', error: '' },
        disables: { ...this.state.disables, Next: false },
      });
    }
    if (page === 2) {
      const { postStudent = {}, postStudentResponse = {} } = this.props;
      const { form, isLoading } = this.state;
      const { current = {} } = postStudentResponse || {};
      const {
        firstName,
        lastName,
        gender,
        grade,
        schoolName,
        ethnicity,
        plusLead,
        phone,
        referrerPhone,
        source,
        information_source,
        google_api_info,
      } = form;

      const studentDetailsForm = {
        firstName,
        lastName,
        gender,
        grade,
        schoolName,
        ethnicity,
        plusLead,
      };
      let payload = {
        action: 'create_student',
        phone,
        first_name: firstName,
        last_name: lastName || '',
        grade: grade && grade.value,
        gender: (gender && gender.value) || '',
        // referrer_phone: referrerPhone,
        source: source && source.value,
        plus_lead: plusLead && plusLead.value,
        ethnicity: ethnicity ? ethnicity.value : undefined,
        school_name: schoolName,
        information_source: information_source && information_source.value,
        google_api_info,
      };
      if (source && source.value === sourceValues.PARENT_REFERRAL) {
        payload = {
          ...payload,
          detail_source: 'LA_REF',
        };
      }

      if (current && current.isCreating) {
        return;
      }

      const requiredFieldsError = {};
      const notFilled = Object.keys(studentDetailsForm).filter(k => {
        if (this.nonOptinalField(k, form)) {
          requiredFieldsError[k] = 'Required';
        }

        return this.nonOptinalField(k, form);
      });

      if (notFilled.length) {
        this.setState({ error: { fields: requiredFieldsError } });
        return;
      }

      if (postStudentResponse && postStudentResponse.isCreating) {
        return;
      }
      if (isLoading) return;
      this.setState({
        isStale: false,
        isLoading: true,
        msgToDisplay: { success: '', error: '' },
        error: {},
      });
      postStudent(parentId, payload);
    }
  };

  onFormChange = (nextData, nextValidation) => {
    const formData = {};
    const { page } = this.state;

    Object.keys(nextData).forEach(k => {
      formData[k] = nextData[k]?.target ? nextData[k].target.value : nextData[k];
    });

    if (page === 1) {
      this.setState({ disables: { ...this.state.disables, Next: true, Save: false } });
    }

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        ...formData,
      },
      validation: {
        ...prevState.validation,
        ...nextValidation,
      },
      error: {},
      msgToDisplay: { success: '', error: '' },
    }));
  };

  nonOptinalField(k, form) {
    const { source = '' } = form || {};
    let mandatoryFields =
      k !== OPTIONS.GENDER &&
      k !== OPTIONS.SCHOOL_NAME &&
      k !== OPTIONS.ETHNICITY &&
      k !== OPTIONS.LAST_NAME &&
      k !== OPTIONS.EMAIL &&
      k !== 'ambassador_checkbox';
    if (source.value === sourceValues.EMPLOYEE_REFERRAL) {
      mandatoryFields =
        mandatoryFields &&
        k !== OPTIONS.REFERRER_COUNTRY_CODE &&
        k !== OPTIONS.REFERRER_PHONE &&
        k !== OPTIONS.EVENT_TYPE &&
        k !== OPTIONS.EVENT_NAME &&
        k !== OPTIONS.INFORMATION_SOURCE;
    } else if (
      source.value === sourceValues.PARENT_REFERRAL ||
      source.value === sourceValues.SALES_REFERRAL
    ) {
      mandatoryFields =
        mandatoryFields &&
        k !== OPTIONS.EMPLOYEE_EMAIL &&
        k !== OPTIONS.EVENT_TYPE &&
        k !== OPTIONS.EVENT_NAME &&
        k !== OPTIONS.INFORMATION_SOURCE;
    } else if (source.value === sourceValues.UAE_LOCAL) {
      mandatoryFields =
        mandatoryFields &&
        k !== OPTIONS.REFERRER_COUNTRY_CODE &&
        k !== OPTIONS.REFERRER_PHONE &&
        k !== OPTIONS.EMPLOYEE_EMAIL &&
        k !== OPTIONS.INFORMATION_SOURCE;
    } else if (source.value === sourceValues.ORGANIC) {
      mandatoryFields =
        mandatoryFields &&
        k !== OPTIONS.REFERRER_COUNTRY_CODE &&
        k !== OPTIONS.REFERRER_PHONE &&
        k !== OPTIONS.EMPLOYEE_EMAIL &&
        k !== OPTIONS.EVENT_TYPE &&
        k !== OPTIONS.EVENT_NAME;
    }
    return mandatoryFields && !form[k];
  }

  openNewTabAndReload(student_id) {
    setTimeout(() => {
      window.location.reload();
    }, 500);
    if (student_id) {
      window.open(`https://leap-admin.cuemath.com/student-form/${student_id}`);
    }
    return;
  }

  render() {
    const {
      form,
      validation,
      error,
      disables,
      page,
      msgToDisplay,
      isLoading,
    } = this.state;
    const { parentData = {}, postStudentResponse, actions } = this.props;
    const { success: successMsg, error: errorMsg } = msgToDisplay || {};
    const { leads = [], referral_link: referralLink } = parentData || {};
    const { source = '' } = form;

    const { resolved: studentResolved } = postStudentResponse || {};
    const { isCreated: isStudentCreated, data: studentData } = studentResolved || {};
    const { intel_enrollment_id: intelEnrollmentId, parent_service_id: parentServiceId } =
      studentData || {};
    return (
      <div>
        {page === 1 && (
          <>
            <Text size="large" weight="bolder">
              Parent Details
            </Text>

            <Form
              nodes={PARENT_FORM}
              values={form}
              validations={validation}
              disables={disables}
              error={error}
              onChange={this.onFormChange}
            />
            {source.value === sourceValues.PARENT_REFERRAL && (
              <>
                <Text size="large" weight="bolder">
                  Referrer Details
                </Text>
                <Form
                  nodes={REFERRAL_FORM}
                  values={form}
                  validations={validation}
                  disables={disables}
                  error={error}
                  onChange={this.onFormChange}
                />
              </>
            )}
            {source.value === sourceValues.EMPLOYEE_REFERRAL && (
              <>
                <Text size="large" weight="bolder">
                  Referee Details
                </Text>
                <Form
                  nodes={EMPLOYEE_REFERRAL_FORM}
                  values={form}
                  validations={validation}
                  disables={disables}
                  error={error}
                  onChange={this.onFormChange}
                />
              </>
            )}
            {source.value === sourceValues.UAE_LOCAL && (
              <>
                <Text size="large" weight="bolder">
                  Event Details
                </Text>
                <Form
                  nodes={UAE_LOCAL_FORM}
                  values={form}
                  validations={validation}
                  disables={disables}
                  error={error}
                  onChange={this.onFormChange}
                />
              </>
            )}
            {source.value === sourceValues.ORGANIC && (
              <>
                <Text size="large" weight="bolder">
                  Information Source
                </Text>
                <Form
                  nodes={ORGANIC_LOCAL_FORM}
                  values={form}
                  validations={validation}
                  disables={disables}
                  error={error}
                  onChange={this.onFormChange}
                />
              </>
            )}
            <Separator transparent height={15} />
          </>
        )}
        {page === 2 && (
          <>
            <Text size="large" weight="bolder">
              Student Details
            </Text>
            <Form
              nodes={STUDENT_FORM}
              values={form}
              validations={validation}
              disables={disables}
              error={error}
              onChange={this.onFormChange}
            />
          </>
        )}
        {referralLink && (
          <>
            <Text size="medium" weight="bolder">
              Referral Link:{' '}
            </Text>
            <CopyButton text={referralLink} copyMessage="Copy" />
          </>
        )}
        <Separator transparent height={15} />
        {parentData && leads.length === 0 && (
          <Row style={{ gap: '15px' }}>
            {page === 1 && (
              <Button
                onClick={this.saveClick}
                busy={isLoading}
                disabled={disables['Save']}
                label="Save"
              />
            )}
            <Button
              onClick={this.nextClick}
              label="Next"
              busy={isLoading & (page === 2)}
              disabled={disables['Next']}
            />
          </Row>
        )}
        {errorMsg && (
          <>
            <Separator height={8} transparent />
            <Text color={COLORS.RED} size="medium" weight="bolder">
              {errorMsg}
            </Text>
          </>
        )}
        {successMsg && (
          <>
            <Separator height={8} transparent />
            <Text color={COLORS.DARK_GREEN} size="medium" weight="bolder">
              {successMsg}
            </Text>
          </>
        )}
        {isStudentCreated && (
          <>
            {actions.openModal(MODAL_FORM.SUCCESS_MODAL)}
            <Text color="#28a745" size="medium" weight="bolder">
              Student added successfully!
            </Text>
            <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
              {intelEnrollmentId && (
                <a
                  href={`https://leap-admin.cuemath.com/student-form/${intelEnrollmentId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View in Leap Admin
                </a>
              )}
              {parentServiceId && (
                <a
                  href={`https://admin.cuemath.com/parent/admin/student/?flt_parent_id_equals=${parentServiceId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Parent's Students
                </a>
              )}
            </div>
          </>
        )}
        <Separator height={50} transparent />
      </div>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators({ openModal }, dispatch),
}))(AddParentStudentForm);

AddParentStudentForm.defaultProps = {
  primaryNumber: '',
};

AddParentStudentForm.propTypes = {
  postParent: PropTypes.func.isRequired,
  parentData: PropTypes.shape({}).isRequired,
  primaryNumber: PropTypes.string,
  postParentResponse: PropTypes.shape({}).isRequired,
};
